import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import {
  getFavSupplierProductsAction,
  removeFavSupplierPoductAction
} from '../../../modules/customerFavSupplierProducts/Actions';

import {
  customerFavSupplierProducsCountSelector,
  customerFavSupplierProducsLoadingSelector,
  customerFavSupplierProductsAsNameAndId,
  searchValueSelector
} from '../../../modules/customerFavSupplierProducts/Selectors';

import List from '../../../components/Lists/List';
import ListItem from '../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import products from '../suppliersModeration/supplierProducts';
import { customerDataSelector } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';

const CustomerFavSupplierProductList = props => {
  const {
    // suppliers,
    // suppliersIsLoading,
    // getSuppliers,
    // deleteSupplier,
    // suppliersCount,
    supplierProducts,
    supplierProductsCount,
    supplierProductsIsLoading,
    getFavSupplierProducts,
    removeFavSupplierProduct,
    customerData
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  // for testing the id remember to remove and use dynamic id
  const customerId = customerData?._id;

  useEffect(() => {
    getFavSupplierProducts({ customerId });
  }, [getFavSupplierProducts]);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    // if (supplierProducts.length >= supplierProductsCount) {
    //   setHasMore(false);
    //   return false;
    // }
    // // otherwise get the data from the database
    // getSuppliers({ size, offset: supplierProducts.length });
  };

  const dataLength =
    supplierProducts.length <= supplierProductsCount
      ? supplierProducts.length
      : supplierProductsCount;

  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={fetchMore}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          isLoading={supplierProductsIsLoading}
          header={{
            items: [getLangData().fields.name],
            actions: ['View', 'Delete']
          }}
          items={supplierProducts}
        >
          <table className='table'>
            <tbody>
              {supplierProducts.map(({ _id, name }) => {
                return (
                  <ListItem
                    name={name}
                    key={_id}
                    viewLink={`/favourite-supplier-products/product/${_id}`}
                    onDelete={() => {
                      const productID = _id;
                      removeFavSupplierProduct(customerId, productID);
                    }}
                  >
                    {console.log(supplierProducts)}
                  </ListItem>
                );
              })}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = state => ({
  supplierProducts: customerFavSupplierProductsAsNameAndId(state),
  supplierProductsIsLoading: customerFavSupplierProducsLoadingSelector(state),
  supplierProductsCount: customerFavSupplierProducsCountSelector(state),
  customerData: customerDataSelector(state)
  // suppliers: pendingSupplierProductsAsListSelector(state),
  // suppliersIsLoading: pendingSupplierProductsIsLoadingSelector(state),
  // suppliersCount: pendingSupplierProductsCountSelector(state),
});

export default connect(mapStateToProps, {
  getFavSupplierProducts: getFavSupplierProductsAction,
  removeFavSupplierProduct: removeFavSupplierPoductAction
  // getSuppliers: getPendingSupplierProductsAction,
  // deleteSupplier:deleteSinglePendingSupplierProdcutAction,
})(CustomerFavSupplierProductList);
